module.exports = __webpack_public_path__ + "img/36.286815b2.jpg";